import { type StateCreator } from 'zustand'

type StepperStoreState = {
  current: number
  name: string
  showButtons: boolean
}

type StepperStoreActions = {
  updateStep: (current: number, name: string) => void
  resetStepper: () => void
  setButtonsVisibility: (showButtons: boolean) => void
}

export type StepperStore = StepperStoreState & StepperStoreActions

const initialState = {
  current: 1,
  name: '',
  showButtons: true
}

export const stepperStoreCreator: StateCreator<StepperStore> = (set) => ({
  ...initialState,
  updateStep: (current: number, name: string) => {
    set(() => ({ current, name }))
  },
  setButtonsVisibility: (showButtons) => {
    set(() => ({ showButtons }))
  },
  resetStepper: () => {
    set(() => ({ ...initialState }))
  }
})
